<i18n>
  {
    "fr": {
      "configuratorEditorThemeChangeModal": {
        "title": "Vous vous apprêtez à modifier le style de votre gobelet.",
        "content": "Vous perdrez toute la configuration en cours de personnalisation.",
        "confirmButton": "Modifier",
        "cancelButton": "Conserver le visuel actuel"
      }
    }
  }
</i18n>

<template>
  <MountingPortal
    mount-to="#portal-container--footer"
    name="configurator-info-modal"
    append
  >
    <BaseModal
      v-model="modalActive"
      hide-close-button
      :close-on-backdrop-click="false"
      :class="`${BLOCK_SELECTOR}`"
      @close="$emit('close')"
    >
      <template #header></template>
      <div :class="`${BLOCK_SELECTOR}__body`">
        <h2 :class="`${BLOCK_SELECTOR}__title`">
          {{ $t('configuratorEditorThemeChangeModal.title') }}
        </h2>
        <p :class="`${BLOCK_SELECTOR}__content`">
          {{ $t('configuratorEditorThemeChangeModal.content') }}
        </p>

        <BaseBtn
          :class="`${BLOCK_SELECTOR}__button ${BLOCK_SELECTOR}__button--confirm`"
          secondary
          block
          @click="$emit('confirm')"
        >
          {{ $t('configuratorEditorThemeChangeModal.confirmButton') }}
        </BaseBtn>
        <BaseBtn
          :class="`${BLOCK_SELECTOR}__button ${BLOCK_SELECTOR}__button--cancel`"
          block
          @click="$emit('close')"
        >
          {{ $t('configuratorEditorThemeChangeModal.cancelButton') }}
        </BaseBtn>
      </div>
    </BaseModal>
  </MountingPortal>
</template>

<script>
import BaseModal from '../../BaseModal';
import BaseBtn from '../../BaseBtn';

export default {
  name: 'ConfiguratorEditorThemeChangeModal',
  emits: ['close', 'confirm'],
  components: { BaseModal, BaseBtn },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BLOCK_SELECTOR: 'configurator-editor-theme-change-modal',
    };
  },
  computed: {
    modalActive: {
      get() {
        return this.isActive;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-editor-theme-change-modal {
  &__body {
    color: $color-arapawa;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    @include breakpoint($breakpoint-l) {
      max-width: 20rem;
    }
  }

  &__title {
    font-size: 1.375rem;
    font-weight: 600;
    margin-bottom: 0.625rem;
  }

  &__content {
    font-size: 1.125rem;
    font-weight: 400;
    margin-bottom: 1.25rem;
  }

  &__button {
    height: 3.4375rem;
    font-size: 1.125rem;
    font-weight: 600;

    &:hover {
      opacity: 0.7;
    }

    &--confirm {
      margin-bottom: 0.625rem;
    }

    &--cancel {
      background-color: transparent;
      color: $color-arapawa;
      border: 1px solid $color-arapawa;
    }
  }

  &::v-deep {
    .base-modal {
      &__body {
        background-color: $color-white;
      }
    }
  }
}
</style>
